/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";

import { Grid, InputAdornment, TextField, Typography } from "@material-ui/core";

import { FormDataConsumer, NumberInput, TextInput } from "react-admin";
import { useForm } from "react-final-form";

import { CustomFields } from "../../../../components/common/CustomFields";
import { trimDecimal } from "../../../../utils/utils";
import { showWeight } from "../../inventory/InventoryUitls";
import { InventorySearchDialog } from "../InventorySearchDialog";
import { PickListInventoryItems } from "./PickListInventoryItems";
import { calculatePickListQuantityState } from "./PickListItemUtils";

export const PickLineItemTab = ({
  record,
  outbound,
  account,
  allInventories,
  isLoaded,
  ...props
}) => {
  const form = useForm();
  const [addOpen, setAddOpen] = useState(false);

  form.registerField(
    "inventoryItems",
    (fieldState) => {
      const { change, ...rest } = fieldState;
    },
    { dirty: true, touched: true, valid: true, value: true },
  );
  form.registerField(
    "inventoryItems.items",
    (fieldState) => {
      const { change, ...rest } = fieldState;
    },
    { dirty: true, touched: true, valid: true, value: true },
  );

  const updateShipmentLineItem = (shipmentItems) => {
    // inventorySearchDialog returns an array of shipmentItems
    const shipmentLineItem = shipmentItems[0];
    debugger;

    form.change("inventoryItems.items", shipmentLineItem.inventoryItems.items);
    const quantityState = calculatePickListQuantityState(record, shipmentLineItem);
    form.change("totalQuantityToPick", quantityState.currentTotalQuantityToPick);
    form.change(
      "inventory.quantityCommitted",
      quantityState.inventoryQuantityCommitted,
    );
  };

  const handleQuantityChange = () => {
    // handles quantity change and row REMOVE
    // 1. Grab the current array of rows from form state
    const inventoryItemsState = form.getFieldState("inventoryItems.items");
    const inventoryItems = inventoryItemsState?.value || [];

    const quantityState = calculatePickListQuantityState(record, {
      ...form.getState().values,
      inventoryItems: { items: inventoryItems },
    });
    form.change("totalQuantityToPick", quantityState.currentTotalQuantityToPick);
    form.change(
      "inventory.quantityCommitted",
      quantityState.inventoryQuantityCommitted,
    );
  };

  return (
    <FormDataConsumer>
      {({ formData, ...rest }) => {
        const quantityState = calculatePickListQuantityState(record, formData);

        return (
          <Grid container direction="column" spacing={1}>
          <Grid container direction="row" spacing={1}>
            <Grid item xs={12} md={6}>
              <TextInput
                source={"inventory.productName"}
                label="Product Name"
                variant="outlined"
                fullWidth
                disabled
                helperText={false}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextInput
                source={"lotNumber"}
                label="Lot No."
                variant="outlined"
                fullWidth
                disabled
                helperText={false}
              />
            </Grid>
            <Grid item xs={false} sm={3}></Grid>
            <Grid item xs={12} md={3}>
              <NumberInput
                source="inventory.quantityOnHand"
                label="Qty. On Hand"
                variant="outlined"
                fullWidth
                disabled
                helperText={false}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">{`${
                      formData.inventory?.inventoryUOM || ""
                    }`}</InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <NumberInput
                source="inventory.quantityCommitted"
                label="Qty. Committed"
                variant="outlined"
                fullWidth
                disabled
                helperText={false}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">{`${
                      formData.inventory?.inventoryUOM || ""
                    }`}</InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label="Qty. Available"
                variant="outlined"
                margin="dense"
                fullWidth
                disabled
                value={trimDecimal(quantityState.inventoryQuantityAvailable, 3)}
                helperText={false}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">{`${
                      formData.inventory?.inventoryUOM || ""
                    }`}</InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <NumberInput
                source="totalQuantityToPick"
                label="Qty. Outbound"
                variant="outlined"
                fullWidth
                disabled={true}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">{`${
                      formData.inventory?.inventoryUOM || ""
                    }`}</InputAdornment>
                  ),
                }}
              />
            </Grid>
            {showWeight(formData.inventory?.account, formData.inventory) && (
              <Grid item xs={12} md={3}>
                <NumberInput
                  source="inventory.weight"
                  label="Weight"
                  variant="outlined"
                  fullWidth
                  disabled
                  helperText={false}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">{`${
                        formData.inventory?.weightUOM || ""
                      }`}</InputAdornment>
                    ),
                  }}
                />
              </Grid>
            )}
            <CustomFields
              {...props}
              source={"inventory.customFields"}
              recordFields={record.inventory?.customFields}
              accountFields={account?.inventoryCustomFields}
              disabled={true}
              width={3}
            />
            <Grid item xs={12}>
              <fieldset>
                <legend>
                  <Typography variant="overline">LOCATIONS</Typography>
                </legend>
                <PickListInventoryItems
                  {...props}
                  record={record}
                  setAddOpen={setAddOpen}
                  handleQuantityChange={handleQuantityChange}
                />
              </fieldset>
              {addOpen && (
                <InventorySearchDialog
                  {...props}
                  form={form}
                  pickListItem={formData}
                  initialPickListItem={record}
                  allInventories={allInventories}
                  isOpen={addOpen}
                  setIsOpen={setAddOpen}
                  isLoaded={isLoaded}
                  updateShipment={updateShipmentLineItem}
                  isContainerPickUp={true} // force location grid
                />
              )}
            </Grid>
          </Grid>
          </Grid>
        );
      }}
    </FormDataConsumer>
  );
};
